import {$, T} from "../../common/drupal/drupal";

class ParagraphCocktail {

    /**
     * Initialize event listeners
     */
    init () {
      // slide Paragraph cocktail
      let slideCocktailId = 0;
      let slideCocktails = [];
      $('.ParagraphCocktail-cocktails').each(function () {
          //Prevent from double initialize
          if($(this).find('.swiper-wrapper').length < 1) {
              $(this).addClass('swiper-container').find('.NodeCocktail-paragraph').addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"></div>');
              $(this).append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
              slideCocktails[slideCocktailId] = new Swiper($(this), {
                  slidesPerView: 1,
                  speed: 500,
                  spaceBetween: 36,
                  centerInsufficientSlides: true,
                  //   centeredSlides: true,
                  //   watchOverflow: true,
                  //   watchSlidesVisibility: true,
                  navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                  },
                  breakpoints: {
                      768: {
                          slidesPerView: 3,
                          centerInsufficientSlides: true,
                      }
                  }
              });
              slideCocktailId++;
          }
      });
    }

    attach(context) {
        this.init(context);
    }
}

export let paragraphCocktail = new ParagraphCocktail();
